import React from "react";
import "./user-dashboard.scss";
const UserDashboard = () => {
    return (
        <>
            <div className="user-dash-container">
                <h1>this is user dashboard</h1>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    Sequi ipsam labore totam reprehenderit perspiciatis quidem
                    incidunt, impedit qui repellat voluptas unde explicabo, esse
                    animi expedita at debitis ullam facere alias.
                </p>
            </div>
        </>
    );
};

export default UserDashboard;
